import React, { FC, useState, useEffect } from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { BreadcrumbsBanner } from '@components/molecules/BreadcrumbsBanner';
import { StickyHeader } from '@components/molecules/StickyHeader/StickyHeader';
import { Space } from '@components/atoms/Space';
import { Container } from '@components/atoms/Container';
import { MarketplaceAdvertising } from '@components/molecules/MarketplaceAdvertising';
import { Footer } from '@components/molecules/Footer';
import { useSettings } from '@hooks/useSettings';
import { useHtmlTransformer } from '@hooks/useHtmlTransformer';

export const Policy: FC = () => {
    const { pageKey } = useParams();
    const { getPage } = useSettings();
    const { transformHtml } = useHtmlTransformer();
    const { t, i18n } = useTranslation();

    const [pageContent, setPageContent] = useState<string | null>(null);

    const translations = {
        title: t(`policy-component.${pageKey}.title`),
    };
    useEffect(() => {
        const fetchPageContent = async () => {
            const content = getPage(pageKey || '');
            setPageContent(content);
        };

        fetchPageContent();
    }, [pageKey, i18n.language, getPage]);

    return (
        <div data-testid="promo-basket-detail">
            <StickyHeader />

            <BreadcrumbsBanner title={translations.title} links={[]} currentPage={translations.title} />

            <Space spaceBreakpoints={{ xs: { space: 50 }, md: { space: 100 } }} />

            <Container classes="px-3">
                <div className="row">
                    <div className="col-12">{pageContent && transformHtml(pageContent)}</div>
                </div>
            </Container>

            <Space spaceBreakpoints={{ xs: { space: 50 }, md: { space: 100 } }} />

            <MarketplaceAdvertising />

            <Footer mode="normal" />
        </div>
    );
};
